<!-- client/src/pages/LoginPage.svelte -->
<script>
  import { navigate } from 'svelte-routing';
  import { user, pendingWebhookEvents, autoSyncOnLogin } from '../stores/authStore';
  import { identifyUser } from '../utils/logrocket';

  let username = '';
  let password = '';
  let error = '';

  function getRedirectUrl() {
    const params = new URLSearchParams(window.location.search);
    const redirect = params.get('redirect');
    if (redirect && redirect.startsWith('/')) {
      const plan = params.get('plan');
      return plan ? `${redirect}?plan=${plan}` : redirect;
    }
    return '/dashboard';
  }

  async function handleSubmit() {
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await response.json();
      if (data.success) {
        // Fetch full user profile (includes country, settings, etc.)
        try {
          const userResponse = await fetch('/api/user', { credentials: 'include' });
          if (userResponse.ok) {
            const userData = await userResponse.json();
            if (userData.success && userData.user) {
              user.set(userData.user);
            } else {
              user.set({ username });
            }
          } else {
            user.set({ username });
          }
        } catch {
          user.set({ username });
        }
        
        // Store pending webhook events count
        if (typeof data.pendingWebhookEvents === 'number') {
          pendingWebhookEvents.set(data.pendingWebhookEvents);
        }

        // Store auto-sync preference
        if (typeof data.autoSyncOnLogin === 'boolean') {
          autoSyncOnLogin.set(data.autoSyncOnLogin);
        }
        
        // Initialize LogRocket and identify user
        identifyUser(username, {
          email: data.email || username
        });
        
        navigate(getRedirectUrl());
      } else {
        error = data.message || 'Login failed';
      }
    } catch (err) {
      error = 'An error occurred. Please try again.';
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-md">
      <div class="text-center">
        <img class="w-3/4 mx-auto h-24 w-auto rounded-md" src="/images/buildzilla-logo-lg.jpg" alt="Logo">
        <!-- <h2 class="mt-6 text-xl font-medium text-gray-900">Please Sign-in</h2>-->
      </div>
      <form on:submit|preventDefault={handleSubmit} class="mt-8 space-y-6">
        <div>
          <label for="username" class="block text-sm font-medium text-gray-700">Username</label>
          <input id="username" name="username" type="text" required bind:value={username} 
                 on:input={(e) => username = e.target.value.toLowerCase()}
                 class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[rgb(178,178,178)] focus:border-[rgb(178,178,178)]">
        </div>
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
          <input id="password" name="password" type="password" required bind:value={password} 
                 class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[rgb(178,178,178)] focus:border-[rgb(178,178,178)]">
        </div>
        {#if error}
          <p class="text-red-600 text-sm">{error}</p>
        {/if}
        <div>
          <button type="submit" 
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#313b55] hover:bg-[rgb(158,158,158)] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[rgb(178,178,178)]">
            Sign in
          </button>
        </div>
        <div class="text-center space-y-2">
          <div>
            <button
              type="button"
              on:click={() => navigate('/request-password-reset')}
              class="text-sm text-gray-600 hover:text-[#313b55] font-medium"
            >
              Forgot password?
            </button>
          </div>
          <div>
            <span class="text-sm text-gray-600">Don't have an account? </span>
            <button
              type="button"
              on:click={() => navigate('/signup')}
              class="text-sm text-[#313b55] hover:text-[rgb(158,158,158)] font-medium"
            >
              Sign up
            </button>
          </div>
        </div>
        <div class="text-center text-sm text-gray-500 mt-4">
          © 2025 All rights reserved
        </div>
      </form>
    </div>
  </div>